import React from "react";
import WarehouseManagement from "src/pages/warehouse-management";

export default function WarehouseManagementPage() {
  return <WarehouseManagement />;
}
